export const juneUppercase = "fra";
export default {juneUppercase};